import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AppLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 768px) {
          .app-navbar {
            flex-direction: column !important;
            align-items: stretch !important;
            padding: 12px 16px !important;
            gap: 10px !important;
          }
          .app-logo-text { font-size: 17px !important; }
          .app-nav-links {
            justify-content: center !important;
            flex-wrap: wrap !important;
            gap: 12px !important;
            order: 3;
          }
          .app-nav-right {
            justify-content: space-between !important;
            order: 2;
          }
          .app-content {
            margin: 16px auto !important;
            padding: 0 12px !important;
          }
        }
      `}</style>
      <nav style={styles.navbar} className="no-print app-navbar">
        <Link to="/dashboard" style={styles.logoLink}>
          <h1 style={styles.logo} className="app-logo-text">🍳 GrubClub</h1>
        </Link>
        <div style={styles.navLinks} className="app-nav-links">
          <Link to="/dashboard" style={styles.navLink}>Dashboard</Link>
          <Link to="/recipes" style={styles.navLink}>Recipes</Link>
          <Link to="/meal-planner" style={styles.navLink}>Meal Planner</Link>
          <Link to="/help" style={styles.navLink}>Help</Link>
          <Link to="/buy-gift" style={styles.navLink}>🎁 Buy Gift</Link>
          <Link to="/redeem-gift" style={styles.navLink}>Redeem Gift</Link>
          {user?.is_admin && <Link to="/admin" style={styles.navLink}>Admin</Link>}
        </div>
        <div style={styles.navRight} className="app-nav-right">
          <span style={styles.welcome}>👋 {user?.name}</span>
          <button onClick={handleLogout} style={styles.logoutBtn}>Logout</button>
        </div>
      </nav>
      <div style={styles.content} className="app-content">{children}</div>
      <footer style={styles.footer} className="no-print">
        <Link to="/terms" style={styles.footerLink}>Terms of Service</Link>
        <span style={styles.footerDivider}>·</span>
        <Link to="/privacy" style={styles.footerLink}>Privacy Policy</Link>
      </footer>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#f5f5f5' },
  navbar: {
    backgroundColor: 'white',
    padding: '16px 32px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  logoLink: { textDecoration: 'none' },
  logo: { color: '#e67e22', margin: 0, fontSize: '24px' },
  navLinks: { display: 'flex', gap: '20px' },
  navLink: { color: '#555', textDecoration: 'none', fontWeight: '600', fontSize: '14px' },
  navRight: { display: 'flex', alignItems: 'center', gap: '16px' },
  welcome: { color: '#555', fontSize: '15px' },
  logoutBtn: {
    padding: '8px 16px',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
  },
  content: { maxWidth: '1000px', margin: '40px auto', padding: '0 20px' },
  footer: {
    textAlign: 'center', padding: '24px 20px', color: '#aaa', fontSize: '12px',
  },
  footerLink: { color: '#aaa', textDecoration: 'none' },
  footerDivider: { margin: '0 8px' },
};

export default AppLayout;
